// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3QKxY","overflowing":"ReadFullNote_overflowing__2o7OF"};